<template>
    <el-card class="brand-list-page">
        <!-- 品牌设置 -->
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="130px"
            class="brand-list-form"
            label-position="left">
            <el-form-item :label="$t('Client.Add.brand_name')" prop="name">
                <div v-if="!isEdit">{{ form.name }}</div>
                <el-input v-else v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Client.Add.brand_logo')" prop="logo">
                <file-upload
                    v-if="isEdit && !form.logo"
                    ref="upload"
                    @input="addImg(arguments, 'logo')">
                    <div class="iconfont icon-fitness-tianjia brand-list-add"></div>
                </file-upload>
                <div class="relative" :class="{'ml-4': isEdit}" style="display: inline-block;">
                    <div
                        v-if="isEdit && form.logo"
                        @click="form.logo = null"
                        class="iconfont icon-fitness-jianshanchu-yuankuang absolute brand-list-delete"></div>
                    <div class="brand-list-logo" :style="`background-image: url(${form.logo})`"></div>
                </div>
            </el-form-item>
            <el-form-item :label="$t('Client.Add.brand_desc')">
                <div v-if="!isEdit">{{ form.introduction }}</div>
                <el-input v-else type="textarea" :rows="5" v-model="form.introduction"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Client.Add.brand_image')">
                <file-upload
                    v-if="isEdit"
                    ref="upload"
                    @input="addImg(arguments, 'images')">
                    <div class="iconfont icon-fitness-tianjia brand-images-add"></div>
                </file-upload>
                <div v-for="(item, i) in form.images" :key="i" class="inline-block relative">
                    <div
                        v-if="item && isEdit"
                        @click="deleteImg(i)"
                        class="iconfont icon-fitness-jianshanchu-yuankuang absolute brand-images-delete"
                    ></div>
                    <div
                        class="brand-list-image"
                        :style="`background-image: url(${item})`">
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="">
                <el-button
                    @click="submit()"
                    type="primary">
                    {{ isEdit ? $t('Common.save') : $t('tooltip.edit') }}
                </el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
import FileUpload from '@/components/base/FileUpload.vue';

export default {
    components: {
        FileUpload,
    },
    data() {
        return {
            form: {
                name: '',
                logo: '',
                introduction: '',
                images: [],
            },
            isEdit: false,
            rules: {},
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            API.get('brand').then(res => {
                this.form = res;
            });
        },
        submit() {
            if (!this.$$filterPermission('设置-品牌设置-品牌资料查看')) this.$router.push('/403');
            else if (!this.isEdit) {
                this.isEdit = true;
                const rules = {
                    name: { required: true, message: this.$t('Client.Add.brand_placeholder') },
                    logo: { required: true, message: this.$t('Message.brand_logo') },
                };
                this.rules = Object.assign({}, rules);
            } else if (this.isEdit) {
                this.postData();
            }
        },
        postData() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                API.put('brand', this.form).then(res => {
                    $ele.$message.success(this.$t('Message.save'));
                    this.rules = null;
                    this.isEdit = false;
                    this.fetchData();
                });
            });
        },
        addImg(arg, type) {
            if (type === 'logo') this.form.logo = arg[0];
            else {
                this.form.images.push(arg[0]);
            }
        },
        deleteImg(index) {
            this.form.images.splice(index, 1);
        },
    },
}
</script>

<style lang="scss">
.brand-list-page {
    // height: 100vh;
    padding: 20px;
}
.brand-list-form {
    width: 48%;
    position: relative;
    // top: 40%;
    top: 45px;
    left: 50%;
    transform: translateX(-50%);
    padding-bottom: 50px;
}
.brand-list-logo {
    width: 60px;
    height: 60px;
    background-size: cover;
    background-position: center;
}
.brand-list-image {
    display: inline-block;
    width: 100px;
    height: 60px;
    background-size: cover;
    background-position: center;
    margin: 0 10px 15px 0;
}
.brand-list-add,
.brand-images-add {
    width: 60px;
    height: 60px;
    border: 1px solid #e6e6e6;
    border-radius: 3px;
    position: relative;
    &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 50px;
        color: #f2f2f2;
    }
}
.brand-images-add {
    width: 100px;
    margin: 0 10px 15px 0;
}
.brand-list-delete,
.brand-images-delete {
    position: absolute;
    right: -6px;
    top: -16px;
    color: #e5004f;
    font-size: 18px;
    z-index: 2;
}
.brand-images-delete {
    right: 2px;
}
</style>
